import { OOOStatisticsState } from '@hkm/components/Maintenance/Statistics/domain/interfaces';
import { Store } from '@hkm/store/interfaces/store';

export const selectOOOStatisticsState = (state: Store): OOOStatisticsState => state.oooStatistics;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Statistics/domain/selectors.ts